import { Component, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { UserManagementService } from './contract/shared/user-management.service';
import { Organisation } from './shared/organisation.model';
import { UserService } from './shared/user.service';
import { Users } from './shared/users.model';
import { Router, NavigationEnd } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  isLoggedIn = false;

  isChatOpen = false;
  selectedTab = 'welcome';
  message = '';
  
  // Chat history to store conversations
  chatHistory: {sender: string, message: string, isBot?: boolean}[] = [
    {sender: 'bot', message: 'Hi I\'m Annabel - Your digital insurance partner from Assura+Protect. I can provide you...', isBot: true}
  ];

  toggleChat() {
    this.isChatOpen = !this.isChatOpen;
    // Reset to welcome tab when opening the chat
    if (this.isChatOpen) {
      this.selectedTab = 'welcome';
    }
  }

  selectTab(tab: string) {
    this.selectedTab = tab;
  }

  sendMessage() {
    if (this.message.trim()) {
      // Add user message to chat history
      this.chatHistory.push({sender: 'user', message: this.message});
      
      // Simulate bot response
      setTimeout(() => {
        this.chatHistory.push({
          sender: 'bot', 
          message: `Thank you for your message about "${this.message}". How else can I help you?`,
          isBot: true
        });
      }, 500);
      
      this.message = '';
    }
  }
  constructor(
    private dateAdapter: DateAdapter<Date>,
    public userService: UserService,
    public usermanagementService: UserManagementService,
    private router: Router
  ) {
    this.dateAdapter.setLocale('en-GB');
  
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Check for error parameters in the URL after navigation
        const urlParams = new URLSearchParams(window.location.search);
        const error = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');
        
        // If we're on a backend path with error, redirect to error page
        if (error && (event.url.includes('/api1/') || event.url.includes('/login'))) {
          this.router.navigate(['/error'], {
            queryParams: {
              type: 'oauth2_callback',
              message: errorDescription || 'OAuth2 authentication failed',
              details: `Error code: ${error}`
            },
            replaceUrl: true
          });
          return;
        }
        
        // Example: assuming login page route is '/login'
        this.isLoggedIn = !!localStorage.getItem('currentUser') && event.url !== '/login';
      }
    });
  }

  async ngOnInit() {
    // Immediately check for error parameters in URL (this runs before any routing)
    this.checkForOAuthErrors();

    // Check for SSO callback parameters
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const username = urlParams.get('username');
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');
    const currentPath = window.location.pathname;

    // Check if this is an OAuth2 error callback - handle both frontend and backend paths
    if (error || 
        currentPath.includes('/login/oauth2/code/') || 
        currentPath.includes('/api1/login/oauth2/code/') ||
        (currentPath.includes('/api1/login') && error) ||
        (currentPath.includes('/login') && error)) {
      
      this.handleOAuthError(error, errorDescription);
      return;
    }

    if (token && username) {
      // Handle SSO callback - redirect to SSO callback component
      this.router.navigate(['/sso-callback'], { 
        queryParams: { token, username },
        replaceUrl: true 
      });
      return;
    }

    const currentUser: Users = JSON.parse(localStorage.getItem('currentUser'));
  
    if (currentUser) {
      this.isLoggedIn = true;
  
      console.log(currentUser, 'users');
      await this.usermanagementService.getTenetById(currentUser.tenantId.toString()).then((res: Organisation) => {
        this.userService.loggedInOrg = res;
        console.log(res, 'res');
      });
  
      await this.usermanagementService.getAUser(currentUser.id.toString()).then((res: Users) => {
        this.userService.loggedinUser = res;
        console.log(this.userService.loggedinUser, 'userId');
      });
    } else {
      this.isLoggedIn = false;
    }
  }

  private checkForOAuthErrors(): void {
    // Check URL immediately for error parameters
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');
    const currentPath = window.location.pathname;

    // If we're on a backend path with error, redirect immediately
    if (error && (currentPath.includes('/api1/') || currentPath.includes('/login'))) {
      this.handleOAuthError(error, errorDescription);
    }
  }

  private handleOAuthError(error: string | null, errorDescription: string | null): void {
    // Extract error details from URL or use defaults
    let errorMessage = errorDescription || 'OAuth2 authentication failed';
    let errorDetails = error ? `Error code: ${error}` : 'The authentication callback could not be processed.';
    
    // Handle specific Azure AD error codes
    if (error === 'access_denied') {
      errorMessage = 'Access denied. You do not have permission to access this application.';
      errorDetails = 'The identity provider denied the authentication request. Please contact your system administrator if you believe this is an error.';
    } else if (error === 'invalid_request') {
      errorMessage = 'Invalid authentication request. Please try logging in again.';
      errorDetails = 'The authentication request was invalid. Please try again.';
    } else if (error === 'server_error') {
      errorMessage = 'Authentication server error. Please try again later.';
      errorDetails = 'An error occurred on the authentication server. Please try again in a few moments.';
    }
    
    this.router.navigate(['/error'], {
      queryParams: {
        type: 'oauth2_callback',
        message: errorMessage,
        details: errorDetails
      },
      replaceUrl: true
    });
  }
  
}
